import AuditLogsView from './audit_logs_view';

export {
    AuditLogsView
};
